import { render, staticRenderFns } from "./InvoiceItemPib.vue?vue&type=template&id=5ebcbf44"
import script from "./InvoiceItemPib.vue?vue&type=script&lang=js"
export * from "./InvoiceItemPib.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports